import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './app.js'
import { startRuntimeBootstrap } from './bootstrap/runtime-api.js'
import './index.css'
import { startInstallPromptCapture } from './install/deferred-install.js'
import { registerServiceWorker } from './service-worker/register.js'

// Capture the deferred install prompt before React mounts — Chromium can fire it during load.
startInstallPromptCapture()

// Kick off boot-time API-domain discovery: probe DGA candidates, adopt the first whose signed
// beacon verifies against the pinned key, and route later API calls through it. Fire-and-forget
// — the install shell renders regardless, and the runtime is consulted by API call sites once
// discovery settles. A failed pass resolves to a defined `unavailable` state, never a hang.
void startRuntimeBootstrap()

const container = document.getElementById('root')
if (!container) throw new Error('Root container #root not found')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

registerServiceWorker()
